import { currenciesZodSchema } from '@mint-lib/currencies-helpers';
import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { LevelTypeEnum } from './mediaData';

export const MediaItemChildOptionsSchema = z.object({
  levelType: LevelTypeEnum,
  levelUrn: z.string().nullable(),
  available: z.array(
    z.object({
      label: z.string(),
      value: z.string(),
    }),
  ),
  added: z.array(
    z.object({
      label: z.string(),
      value: z.string(),
    }),
  ),
});

export const GetMediaItemChildOptionsResponseSchema = createResponseSchema(
  MediaItemChildOptionsSchema,
);

export const AddMediaItemChildrenRequestSchema = z.object({
  levelEntitiesIds: z.array(z.string()),
});

export const AddMediaRowsRequestSchema = z.object({
  mediaRowsCount: z.number(),
});

export const GetMediaItemDetailsResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    activityId: z.string(),
    levelType: z.string(),
    isConfigured: z.boolean(),
    currency: currenciesZodSchema,
    budget: z.string().nullable(),
    dateFrom: z.string().nullable(),
    dateTo: z.string().nullable(),
  }),
);

export const MediaItemCurrencyRateResponseSchema = createResponseSchema(
  z.object({
    rate: z.string(),
    rateType: z.string(),
  }),
);

export const MediaItemCurrencyRateQuerySchema = z.object({
  fromCurrency: z.string(),
  toCurrency: z.string(),
});

export const AssignAdAccountQuerySchema = z.object({
  adAccountId: z.string(),
  currency: z.string(),
});

export const AssignAdAccountResponseSchema = z.object({
  data: z.string().nullable(),
  error: z
    .object({
      type: z.string(),
      message: z.string(),
      code: z.number(),
    })
    .nullable(),
});
